module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-main",
    attrs: {
      "id": "menu"
    }
  }, [_c('ul', {
    staticClass: "accordion"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paieEnable),
      expression: "paieEnable"
    }]
  }, [_c('div', {
    ref: "favLi",
    class: _vm.favoris.length === 0 ? 'empty toggle' : 'toggle',
    attrs: {
      "data-testid": "menu-favoris"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n\t\t\t\t\t\t\tFAVORIS\n\t\t\t\t\t\t\t"), (_vm.favoris.length > 0) ? _c('span', {
    staticClass: "icn fa-solid fa-fw fa-chevron-right arrow"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    ref: "innerFav",
    staticClass: "inner tw-relative"
  }, [_c('div', {
    staticClass: "tw-w-12 tw-h-full tw-bg-[#044f82] tw-absolute tw-left-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "left tw-w-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('ul', _vm._l((_vm.favoris), function(favori) {
    return _c('li', {
      staticClass: "tw-flex tw-transition-all tw-items-center tw-duration-200 hover:tw-bg-gray-100",
      on: {
        "click": function($event) {
          _vm.execFavorite(favori.Key)
        }
      }
    }, [_c('div', {
      staticClass: "tw-grow tw-pl-3 ellipsis",
      attrs: {
        "title": favori.Libelle,
        "data-testid": "menu-favoris-entry"
      }
    }, [_vm._v("\n                                        " + _vm._s(favori.Libelle) + "\n                                    ")]), _vm._v(" "), _c('div', {
      staticClass: "tw-flex tw-justify-center tw-items-center hover:tw-bg-gray-200 tw-w-8 tw-min-w-[2rem] tw-h-8 tw-rounded-full tw-mr-1",
      class: _vm.disableFav ? 'tw-text-gray-300 tw-cursor-default' : 'tw-text-red-400',
      attrs: {
        "title": "Supprimer le favori"
      },
      on: {
        "click": function($event) {
          _vm.removeFavorite(favori.Key, favori.Libelle, true, $event)
        }
      }
    }, [_c('span', {
      staticClass: "fa-solid fa-xmark"
    })])])
  }))])])])]), _vm._v(" "), _vm._l((_vm.menuModel.categories), function(categorie) {
    return (_vm.canShow(categorie.head)) ? _c('li', [_c('div', {
      staticClass: "toggle",
      attrs: {
        "data-cy": categorie.head.dataCy,
        "data-testid": categorie.head.dataTestId
      }
    }, [_c('div', {
      staticClass: "tw-flex"
    }, [_c('div', {
      staticClass: "left tw-w-12"
    }, [_c('span', {
      staticClass: "icn fa-light fa-fw fa-sm",
      class: categorie.head.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(categorie.head.name) + "\n\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "icn fa-solid fa-fw fa-chevron-right arrow"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "tw-flex"
    }, [_c('div', {
      staticClass: "left tw-w-12"
    }), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('ul', _vm._l((categorie.child), function(child) {
      return (_vm.canShow(child)) ? _c('li', {
        staticClass: "tw-flex tw-transition-all tw-items-center tw-duration-200 hover:tw-bg-gray-100 tw-pl-3",
        attrs: {
          "data-cy": child.dataCy,
          "data-testid": child.dataTestId
        },
        on: {
          "click": function($event) {
            _vm.openAction(child)
          }
        }
      }, [(!!child.icone) ? _c('div', {
        staticClass: "icon tw-w-[1.1rem] tw-mr-1",
        domProps: {
          "innerHTML": _vm._s(child.icone)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "tw-grow ellipsis",
        style: ({
          color: child.nameColor
        }),
        attrs: {
          "title": child.name
        }
      }, [_vm._v("\n                                        " + _vm._s(child.name) + "\n                                    ")]), _vm._v(" "), (child.enableFav && _vm.paieEnable) ? _c('div', {
        staticClass: "tw-flex tw-justify-center tw-items-center hover:tw-bg-gray-200 tw-w-8 tw-min-w-[2rem] tw-h-8 tw-rounded-full tw-mr-1",
        class: _vm.disableFav ? 'tw-text-gray-300 tw-cursor-default' : 'tw-text-yellow-400',
        attrs: {
          "title": [_vm.isFavorite(child.id) ? 'Supprimer' : 'Ajouter'] + ' le favori'
        },
        on: {
          "click": function($event) {
            _vm.toggleFav(child, categorie.head, !_vm.isFavorite(child.id), $event)
          }
        }
      }, [_c('span', {
        staticClass: "fa-star ",
        class: _vm.isFavorite(child.id) ? 'fa-solid' : 'fa-regular'
      })]) : _vm._e()]) : _vm._e()
    }))])])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('modal-cloture-paie', {
    ref: "modalCloturePaie"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left tw-w-12"
  }, [_c('span', {
    staticClass: "icn fa-light fa-fw fa-star fa-sm"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-785504f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu.vue.html
// module id = myXj
// module chunks = 2